import { RootState } from '../../../index'

export const selectNewUserRoles = (state: RootState): string[] =>
	state.appReducer.clinicManagement?.newUser?.roles || []
export const selectNewUserCV = (state: RootState): string =>
	state.appReducer.clinicManagement?.newUser?.cv || ''
export const selectNewUserAva = (state: RootState): string =>
	state.appReducer.clinicManagement?.newUser?.ava || ''

